<div class="modal fade" id="data-filter-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="dataFilterModalLabel">{{ 'Data Filter Modal' | translate }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="row data-filter-container">
                    
                    <ng-container *ngFor="let dropdownDatum  of dropdownData; let i = index">
                        <ng-container *ngIf="dropdownDatum.ready">
                            
                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                               
                                <div class="row filter-row-padding">
                                    <div class="col-md-4 col-lg-4 col-sm-4 col-xs-4">
                                        {{dropdownDatum.display | translate}}
                                    </div>
                                    <div class="col-md-8 col-lg-8 col-sm-8 col-xs-8">
                                        <!-- <ng-multiselect-dropdown [placeholder]="'Select'" [data]="dropdownDatum.values"   -->
                                        <ng-multiselect-dropdown [settings]="dropdownSettings" placeholder="{{ 'Click here to select value' | translate }}" [data]="dropdownDatum.values" 
                                            [(ngModel)]="dropdownDatum.selectedValues" >
                                        </ng-multiselect-dropdown>
                                    </div>
                                </div>                                      
                            </div>
                        </ng-container>
                    </ng-container>
                    
                </div> 
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="handleFilters()" data-dismiss="modal">Ok</button>
                <button type="button" class="btn btn-default btn-space" data-dismiss="modal">Cancel</button>
            </div>

        </div>
    </div>
</div>